import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=5a0e9683&scoped=true"
import script from "./SearchItem.vue?vue&type=script&lang=js"
export * from "./SearchItem.vue?vue&type=script&lang=js"
import style0 from "./SearchItem.vue?vue&type=style&index=0&id=5a0e9683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e9683",
  null
  
)

export default component.exports